import { render, staticRenderFns } from "./TaskCard.vue?vue&type=template&id=ebe83e38&"
import script from "./TaskCard.vue?vue&type=script&lang=js&"
export * from "./TaskCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports